




























































































































import mixins from 'vue-typed-mixins';
import { HumanResourcesOptions } from '.';
import humanresourcetypes from '../components/humanresources/humanresourcestypes';
import DataSetUtils, { DataSet } from '@/utils/DataSetUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => HumanResourcesOptions,
    },
  },
  computed: {
    positioncounttypes(): string[] {
      return Object.keys(humanresourcetypes);
    },
    languages(): any {
      return this.value.language ? Object.keys(this.value.language) : [];
    },
    datasetOptions(): any {
      return this.datasets?.map((dataset) => ({
        text: dataset.name,
        value: { key: dataset.key },
      }));
    },
  },
  data(): {
    datasets?: DataSet[];
  } {
    return {
      datasets: undefined,
    };
  },
  mounted() {
    this.loadDataSets(); // async load
    // set  values to defaults
    this.$emit('input', {
      source: 'sub_organization',
      positioncounttype: undefined,
      department: {
        active: false,
        label: undefined,
      },
      position: {
        active: false,
        label: undefined,
      },
      language: this.defaultLanguages(),
      ...this.value,
    });
  },
  watch: {
    'value.department.active'() {
      if (!this.value.department.active) {
        this.value.department.label = undefined;
      } else if (!this.value.department.label) {
        this.value.department.label = this.$languageobj(
          'model.question.options.human_resources.department.labelDefault'
        );
      }
    },
    'value.position.active'() {
      if (!this.value.position.active) {
        this.value.position.label = undefined;
      } else if (!this.value.position.label) {
        this.value.position.label = this.$languageobj(
          'model.question.options.human_resources.position.labelDefault'
        );
      }
    },
    'value.positioncounttype'(positioncounttype: any) {
      this.value.language = this.defaultLanguages();
    },
  },
  methods: {
    defaultLanguages() {
      if (this.value.positioncounttype === 'Manitoba_v1') {
        return {
          totalfte: this.$languageobj(
            'model.question.options.human_resources.language.totalfte'
          ),
          dbpfilledwith: this.$languageobj(
            'model.question.options.human_resources.language.dbpfilledwith'
          ),
          dbpfilledwithout: this.$languageobj(
            'model.question.options.human_resources.language.dbpfilledwithout'
          ),
          vacant: this.$languageobj(
            'model.question.options.human_resources.language.vacant'
          ),
          nondbp: this.$languageobj(
            'model.question.options.human_resources.language.nondbp'
          ),
          ...this.value.language,
        };
      } else if (this.value.positioncounttype === 'Simple_v1') {
        return {
          total: this.$languageobj(
            'model.question.options.human_resources.language.total'
          ),
          nondbp: this.$languageobj(
            'model.question.options.human_resources.language.nondbp'
          ),
          ...this.value.language,
        };
      } else {
        return undefined;
      }
    },
    async loadDataSets() {
      try {
        this.$alert.hide('loadDataSets');
        this.datasets = await DataSetUtils.api.dataset.list();
      } catch (error) {
        this.$alert.show('loadDataSets', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },
  },
});
